function truncateText(el) {
    var input = jQuery(el).text();

    if (input.length > 230) {
        var newInput = input.substring(0, 230) + '...';
        jQuery(el).text(newInput);
    }
}

export default truncateText;